import { configureStore } from '@reduxjs/toolkit';
import menuSideReducer from "../Menu/MenuSide/menuSideSlice";
import quizReducer from "../MainVIew/Quiz/quizSlice";
import adminReducer from "../Admin/adminSlice";
import adminUsersReducer from "../Admin/adminUserSlice";
//auth
import authReducer from "../Authorization/authSlice";
import userReducer from "../FirstMain/userSlice";
//..
import accountReducer from "../MainVIew/Account/accountSlice"
import notesReducer from "../MainVIew/Notes/noteslice";
import troubleReducer from "../MainVIew/Troubles/troubleslice";
import libraryReducer from '../MainVIew/Library/libraryslice';
import messagesReducers from '../MainVIew/Messages/messageslice';
import contactsReducers from '../MainVIew/Contacts/contactsSlice';
import  tasksReducers  from '../MainVIew/Tasks/taskSlice';

export default configureStore ({
   reducer: {
    menuSide: menuSideReducer,
    quiz: quizReducer,
    admin: adminReducer,
    adminUsers: adminUsersReducer,
     //add auth
     auth: authReducer,
     user: userReducer,  
     //..
     account: accountReducer,
     notes: notesReducer,
     troubles: troubleReducer,
     library: libraryReducer,
     messages:messagesReducers,
     contacts: contactsReducers,
     tasksMain: tasksReducers,
   } 
});

/*
const store = configureStore ({
   reducer: {
    menuSide: menuSideReducer,
    quiz: quizReducer,
    admin: adminReducer,
    adminUsers: adminUsersReducer,
     //add auth
     auth: authReducer,
     user: userReducer,  
     //..
     account: accountReducer,
     notes: notesReducer,
     troubles: troubleReducer,
     library: libraryReducer,
     messages:messagesReducers,
     contacts: contactsReducers,
   } 
})
  
export default store;
 */